import { render, staticRenderFns } from "./InfoPubCoopDetail.vue?vue&type=template&id=b997cc14&scoped=true"
import script from "./InfoPubCoopDetail.vue?vue&type=script&lang=js"
export * from "./InfoPubCoopDetail.vue?vue&type=script&lang=js"
import style0 from "./InfoPubCoopDetail.vue?vue&type=style&index=0&id=b997cc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b997cc14",
  null
  
)

export default component.exports